export const sm = (strings) => `@media screen and (min-width: 36em) {
  ${strings.join("")}
}`

export const md = (strings) => `@media screen and (min-width: 48em) {
  ${strings.join("")}
}`

export const lg = (strings) => `@media screen and (min-width: 62em) {
  ${strings.join("")}
}`
